<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card" style="margin-top: 50px">
        <Header />
        <div class="card-body">
          <div v-if="!showEmployeeList" class="approval-hero mb-4">
            <div class="approval-filter-panel">
              <div class="approval-filter-header">
                <div>
                  <h5 class="mb-1">Approval Scope</h5>
                  <small class="text-muted">Prioritas karyawan dengan completion approval pending, pencarian mencakup semua karyawan BIB.</small>
                </div>
                <span class="approval-count-pill">{{ pendingApprovalCount }} pengajuan</span>
              </div>

              <div class="approval-filter-grid">
                <div class="approval-control">
                  <label>IDP Period</label>
                <v-select
                  :options="idpPeriodOptions"
                  v-model="selectedPeriodOption"
                  label="text"
                  placeholder="-- Select a period --"
                />
                </div>

              </div>
            </div>

            <div class="approval-info-grid">
              <div class="approval-info-card">
                <span>Employee</span>
                <strong>{{ selectedEmployeeName }}</strong>
                <small>{{ filters.nik || '-' }}</small>
              </div>
              <div class="approval-info-card">
                <span>Position</span>
                <strong>{{ position || '-' }}</strong>
                <small>Current selected employee</small>
              </div>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="backToEmployeeList">
                <i class="fe fe-arrow-left mr-1"></i>
                Back to list
              </button>
            </div>
          </div>

          <div v-if="showEmployeeList" class="approval-list-shell mb-4">
            <div class="tna-summary-grid mb-4">
              <div class="tna-summary-card">
                <div>
                  <span class="summary-eyebrow">Karyawan</span>
                  <strong>{{ employeeListTotalRecords }}</strong>
                  <small>Dalam scope monitoring</small>
                </div>
                <i class="fe fe-users"></i>
              </div>
              <div class="tna-summary-card primary">
                <div>
                  <span class="summary-eyebrow">Pengajuan Page Ini</span>
                  <strong>{{ employeeListTotalSubmissions }}</strong>
                  <small>Menunggu approval pada daftar tampil</small>
                </div>
                <i class="fe fe-layers"></i>
              </div>
              <div class="tna-summary-card">
                <div>
                  <span class="summary-eyebrow">Page Ini</span>
                  <strong>{{ subordinates.length }}</strong>
                  <small>Karyawan pada halaman ini</small>
                </div>
                <i class="fe fe-list"></i>
              </div>
            </div>

            <div class="approval-filter-panel">
              <div class="approval-filter-header">
                <div>
                  <h5 class="mb-1">Approval Scope</h5>
                  <small class="text-muted">Daftar menampilkan karyawan BIB sesuai scope. Completion yang menunggu approval tampil paling atas.</small>
                </div>
              </div>
              <div class="approval-filter-grid">
                <div class="approval-control">
                  <label>IDP Period</label>
                  <v-select :options="idpPeriodOptions" v-model="selectedPeriodOption" label="text" placeholder="-- Select a period --" />
                </div>
              </div>
            </div>
          </div>

          <Tabs :activeTab="activeTab" @tab-changed="onTabChange" :is-loading="isLoading" />

          <ApprovalEmployeeList
            v-if="showEmployeeList"
            :rows="subordinates"
            :search.sync="employeeListSearch"
            :is-loading="isLoadingEmployeeList"
            :total="employeeListTotalRecords"
            :page="employeeListPage"
            :page-size="employeeListPageSize"
            :showing-from="employeeListShowingFrom"
            :showing-to="employeeListShowingTo"
            @search="onEmployeeListSearch"
            @detail="selectApprovalEmployee"
            @page-change="onEmployeeListPageChange"
            @per-page-change="onEmployeeListPerPageChange"
          />

          <template v-else>
          <Summary :isLoadingSummary="isLoadingSummary" :summaryData="summaryIdpLearningReport" />

          <div class="course-list-toolbar mb-4">
            <div class="course-list-title">
              <h4 class="mb-1 font-weight-bold">Course List</h4>
              <small class="text-muted">Pantau semua completion pada periode dan learning type yang dipilih.</small>
            </div>
            <div class="course-list-actions">
              <b-form-select
                :disabled="!filters.nik"
                :value="filters.status"
                :options="statusFilterOptions"
                class="course-status-filter"
                @input="onStatusFilterChange"
              />
              <b-form-input
                :disabled="!filters.nik"
                class="course-search-input"
                v-model="filters.search"
                placeholder="Search training..."
                @keyup.enter="onSearch"
              />
              <button
                type="button"
                class="btn btn-outline-danger position-relative course-filter-btn"
                @click="showFilterModal"
                :disabled="!filters.nik"
              >
                <span class="fe fe-sliders mr-1"></span> Filter
                <span
                  v-if="activeFiltersCount > 0"
                  class="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                  style="font-size: 0.65rem; padding: 0.2rem 0.4rem"
                >
                  {{ activeFiltersCount }}
                </span>
              </button>
            </div>
          </div>

          <div v-if="activeFiltersCount > 0" class="mb-3">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <small class="text-muted">Active Filters:</small>

              <span v-if="filters.status" class="badge bg-light text-dark border">
                Status: {{ getOptionLabel(statusFilterOptions, filters.status) }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('status')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_scope" class="badge bg-light text-dark border">
                Training Scope: {{ filters.training_scope }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_scope')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_category" class="badge bg-light text-dark border">
                Training Category: {{ filters.training_category === 'mandatory' ? 'Mandatory' : 'Development' }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_category')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.coaching_type_id" class="badge bg-light text-dark border">
                Coaching Type: {{ filters.coaching_type_id }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('coaching_type_id')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.platform" class="badge bg-light text-dark border">
                Platform: {{ filters.platform }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('platform')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_method_id" class="badge bg-light text-dark border">
                Training Method: {{ getOptionLabel(trainingMethods, filters.training_method_id) }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_method_id')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.training_type" class="badge bg-light text-dark border">
                Training Type: {{ getOptionLabel(trainingTypes, filters.training_type) }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('training_type')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <span v-if="filters.competency_id" class="badge bg-light text-dark border">
                Competency: {{ getOptionLabel(competencies, filters.competency_id) }}
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  @click="clearSingleFilter('competency_id')"
                  style="font-size: 0.6rem; padding: 0.1rem"
                ></button>
              </span>

              <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2" @click="resetFilters">Clear All</button>
            </div>
          </div>

          <ReportTable
            :rows="idpLearningReport.data"
            :total="idpLearningReport.totalItems"
            :showing-from="showingFrom"
            :showing-to="showingTo"
            :page="filters.page"
            :page-size="filters.pageSize"
            :is-loading-approve="isLoadingApprove"
            :learning-type="filters.learning_type"
            @sort-change="onSortChange"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
            @page-change-from-bv="onPageChangeFromBv"
            @view-detail="handleViewDetail"
          />

          <SocialLearningModal
            v-if="filters.learning_type === 'social_learning'"
            :modal-id="'social-learning-modal'"
            :data="modalData"
            :is-loading="isModalLoading"
            @close="showModal = false"
            @open-update-summary-modal="showUpdateSummaryModal"
            @complete="handleComplete"
          />

          <modal-filter
            v-if="filters.nik"
            v-model="filters"
            @apply-filters="applyFilters"
            @reset-filters="resetFilters"
            :training-type-options="trainingTypes"
            :competency-options="competencies"
            :training-method-options="trainingMethods"
            :learning-type="filters.learning_type"
          />

          <SummaryModal
            v-if="filters.learning_type === 'social_learning'"
            :modal-id="'update-summary-modal'"
            :data="summaryData"
            :is-loading="isUpdateSummaryLoading"
            @update-summary="updateSummary"
          />

          <ConfirmationSubmitModal
            :showConfirmationSubmit="showConfirmationSubmitModal"
            @close="showConfirmationSubmitModal = false"
            :data="modalData"
            :isSubmitting="isSubmitting"
            @submit="completeCoaching"
          />

          <ExperientialLearningModal
            v-if="filters.learning_type === 'experiential_learning'"
            :modal-id="'experiential-learning-modal'"
            :data="modalData"
            :is-loading="isModalLoading"
            @close="showModal = false"
            @open-update-activity-modal="showUpdateActivityModal"
          />

          <ActivityModal
            v-if="filters.learning_type === 'experiential_learning'"
            :modal-id="'update-activity-modal'"
            :data="activityData"
            :is-loading="isSubmitFeedbackLoading"
            @submit-feedback="submitFeedback"
          />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logic from "./main.logic";
import ApprovalEmployeeList from "../components/approval-employee-list.vue";
import Header from "./components/header.vue";
import Summary from "../course-completion/components/summary.vue";
import ModalFilter from "./modal/filter-modal.vue";
import ReportTable from "./table/report-table.vue";
import Tabs from "./components/tabs.vue";
import SocialLearningModal from "./modal/social-learning-modal.vue";
import SummaryModal from "./modal/summary-modal.vue";
import ConfirmationSubmitModal from "./modal/confirmation-submit-modal.vue";
import ExperientialLearningModal from "./modal/experiential-learning-modal.vue";
import ActivityModal from "./modal/activity-modal.vue";

export default {
  name: "IdpCourseCompletionReportPage",
  components: {
    ApprovalEmployeeList,
    Header,
    Summary,
    ReportTable,
    ModalFilter,
    Tabs,
    SummaryModal,
    SocialLearningModal,
    ConfirmationSubmitModal,
    ExperientialLearningModal,
    ActivityModal,
  },
  mixins: [logic],
};
</script>

<style scoped>
.approval-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 0.9fr);
  gap: 16px;
}

.tna-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.tna-summary-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 92px;
  border: 1px solid #e9edf5;
  border-radius: 8px;
  background: #fff;
  padding: 18px;
  box-shadow: 0 8px 22px rgba(31, 45, 61, 0.04);
}

.tna-summary-card.primary {
  border-color: #ffd3d6;
  background: #fffafb;
}

.tna-summary-card strong {
  display: block;
  color: #1f2937;
  font-size: 28px;
  line-height: 1;
  margin: 6px 0;
}

.tna-summary-card small,
.summary-eyebrow {
  color: #8aa0c7;
  font-weight: 700;
}

.tna-summary-card i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background: #fff1f2;
  color: #e11d2e;
  font-size: 20px;
}

.approval-filter-panel,
.approval-info-card {
  border: 1px solid #e9edf5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(31, 45, 61, 0.04);
}

.approval-filter-panel {
  padding: 16px;
}

.approval-filter-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.approval-count-pill {
  white-space: nowrap;
  border-radius: 999px;
  background: #fff1f2;
  color: #b4232e;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
}

.approval-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 14px;
}

.approval-control label,
.approval-info-card span {
  display: block;
  color: #4b587c;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
}

.approval-info-grid {
  display: grid;
  gap: 12px;
}

.approval-info-card {
  min-height: 88px;
  padding: 16px;
}

.approval-info-card strong {
  display: block;
  color: #1f2937;
  font-size: 16px;
  line-height: 1.25;
  word-break: break-word;
}

.approval-info-card small {
  color: #8ea1bf;
  font-weight: 600;
}

.employee-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.employee-option strong {
  color: #1f2937;
  font-size: 13px;
}

.employee-option small {
  color: #8ea1bf;
  font-weight: 600;
}

.course-list-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid #eef1f6;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(31, 45, 61, 0.04);
}

.course-list-title {
  min-width: 220px;
}

.course-list-actions {
  display: grid;
  grid-template-columns: minmax(170px, 190px) minmax(240px, 360px) auto;
  align-items: center;
  gap: 10px;
}

.course-status-filter,
.course-search-input,
.course-filter-btn {
  min-height: 36px;
}

.course-filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .approval-hero,
  .approval-filter-grid,
  .course-list-actions {
    grid-template-columns: 1fr;
  }

  .course-list-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
